import CustomEvent from './CustomEvent';
import Event from './Event';
import EventTarget from './EventTarget';
export { CustomEvent, Event, EventTarget as default };
//# sourceMappingURL=index.js.map